import { __rest } from "tslib";
import * as React from 'react';
import StarIcon from '@patternfly/react-icons/dist/esm/icons/star-icon';
import { Button } from '@patternfly/react-core/dist/esm/components/Button/Button';
export var FavoritesCell = function FavoritesCell(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      onFavorite = _a.onFavorite,
      isFavorited = _a.isFavorited,
      rowIndex = _a.rowIndex,
      props = __rest(_a, ["className", "onFavorite", "isFavorited", "rowIndex"]);

  var ariaProps = rowIndex === undefined ? {} : {
    id: "favorites-button-".concat(rowIndex),
    'aria-labelledby': "favorites-button-".concat(rowIndex)
  };
  return React.createElement(Button, Object.assign({
    variant: "plain",
    className: className,
    type: "button",
    "aria-label": isFavorited ? 'Starred' : 'Not starred',
    onClick: onFavorite
  }, ariaProps, props), React.createElement(StarIcon, {
    "aria-hidden": true
  }));
};
FavoritesCell.displayName = 'FavoritesCell';